import PropTypes from 'prop-types';
import {generateTipCountLabel} from '../simpleTransferTaskHelper';

function TaskEjectTipDescription({rowTipCount, columnTipCount, showCaddyNumber, caddyNumber}) {
  return (
    <>
      &nbsp;
      <span style={{fontWeight: 'bold'}}>to</span>
      &nbsp;
      <span>{showCaddyNumber ? `Tip Caddy #${caddyNumber}` : 'Waste Bin'}</span>
      &nbsp;
      <span className="green">{generateTipCountLabel(rowTipCount, columnTipCount)}</span>
    </>
  );
}

TaskEjectTipDescription.propTypes = {
  rowTipCount: PropTypes.string,
  columnTipCount: PropTypes.string,
  showCaddyNumber: PropTypes.bool.isRequired,
  caddyNumber: PropTypes.number.isRequired,
};

TaskEjectTipDescription.defaultProps = {
  columnTipCount: '',
  rowTipCount: '',
};

export default TaskEjectTipDescription;
